import * as React from 'react';
import { template } from '../../register';
import { TemplateViewport } from '../layout/TemplateViewport';

const { Template, TemplateContextProvider } = template;

const Estate: React.FC = () => {
  return (
    <TemplateContextProvider isObjectPage>
      <TemplateViewport>
        <Template />
      </TemplateViewport>
    </TemplateContextProvider>
  );
};

export default Estate;
